/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Residue
 */
export interface Residue {
    /**
     * 
     * @type {number}
     * @memberof Residue
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof Residue
     */
    aminoAcid: string;
}

/**
 * Check if a given object implements the Residue interface.
 */
export function instanceOfResidue(value: object): value is Residue {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('aminoAcid' in value) || value['aminoAcid'] === undefined) return false;
    return true;
}

export function ResidueFromJSON(json: any): Residue {
    return ResidueFromJSONTyped(json, false);
}

export function ResidueFromJSONTyped(json: any, ignoreDiscriminator: boolean): Residue {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'],
        'aminoAcid': json['aminoAcid'],
    };
}

export function ResidueToJSON(json: any): Residue {
    return ResidueToJSONTyped(json, false);
}

export function ResidueToJSONTyped(value?: Residue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'aminoAcid': value['aminoAcid'],
    };
}

